import Icon from 'components/shared/Icon/Icon'
import { pathwayPath } from 'helpers/Pathway'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import './ProjectPathwayBanner.scss'

export const ProjectPathwayBanner = ({ slug, pathwayTitle, locale, t }) => {
  return (
    <>
      {slug && pathwayTitle && (
        <div className="c-project-pathway-banner__container">
          <Link
            className="c-project-pathway-banner__text-link"
            to={pathwayPath(locale, slug)}
          >
            <Icon
              type="arrow-down"
              className="c-project-pathway-banner__text-link-icon"
            />
            {pathwayTitle} {t('project.header.path', { defaultValue: '' })}
          </Link>
        </div>
      )}
    </>
  )
}

export default ProjectPathwayBanner

ProjectPathwayBanner.propTypes = {
  slug: PropTypes.string,
  pathwayTitle: PropTypes.string,
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}
